import{useContext as t}from"react";import{TabsContext as o}from"./tabsContext.js";const r=()=>{const r=t(o);if(void 0===r)throw new Error("useTabsContext must be used within Tabs");return r};export{r as useTabsContext};
//# sourceMappingURL=useTabsContext.js.map
